import { FormationDetailProps } from "@/types/formation";

export const verificateurEpiFormation: FormationDetailProps = {
  id: "14",
  title: "Formation Vérificateur EPI",
  description: "Formation permettant d'acquérir les compétences nécessaires pour vérifier et contrôler les équipements de protection individuelle (EPI) contre les chutes de hauteur.",
  duration: "7 heures (1 jour)",
  category: "Sécurité",
  imageSrc: "/images/formations/verificateurepi.webp",
  slug: "verificateur-epi",
  reference: "F-VECCH",
  price: "Sur devis – nous contacter",
  targetAudience: "Toute personne amenée à porter et utiliser un harnais pour un travail en hauteur en situation simple",
  prerequisites: [
    "Être reconnu médicalement apte au travail en hauteur et en bonne condition physique, ne pas avoir d'appréhension du vide",
    "Avoir à sa disposition des EPI adaptés au travail et à l'environnement",
    "Maîtriser la langue française pour une bonne compréhension"
  ],
  objectives: [
    "Comprendre à partir de quels matériaux sont composés les EPI contre les chutes de hauteur et connaitre leurs caractéristiques et prendre en compte de ces matériaux",
    "Savoir interpréter les normes et leur importance sur les technologies des équipements",
    "Procéder à la vérification périodique des EPI et à l'mise à jour du registre de sécurité",
    "Savoir renseigner les documents adaptés (support de vérification des EPI)"
  ],
  program: [
    {
      title: "Partie théorique",
      items: [
        "Les textes réglementaires concernant l'obligation de vérification périodique (directive 89/686/CEE, 89/656 CEE, arrêtés du 19 mars 1993 et du 22/10/2009)",
        "Les obligations légales par rapport aux EPI",
        "Les règles de notifications légales par rapport aux EPI",
        "Les registres de sécurité",
        "Les matériaux utilisés pour les EPI contre les chutes de hauteur (textiles, métalliques, composites)",
        "Inspection, recensement, stockage, étiquetage, entrée de vigilance",
        "Comment renseigner un procès-verbal, les modalités et le transfert à son équipe",
        "Introduction aux différentes normes"
      ]
    },
    {
      title: "Partie pratique",
      items: [
        "L'objectif est de maîtriser la vérification des EPI contre les chutes de hauteur et de renseigner les documents adéquats",
        "La méthodologie de la vérification des EPI contre les chutes de hauteur (préparation, inspection)",
        "Les vérifications sont réalisées sur chaque élément avec check-list + des situations réelles",
        "EN 795 TYPE B",
        "EN 358",
        "EN 353-2",
        "EN 1891",
        "EN 353-1",
        "EN 353-2",
        "EN 355",
        "EN 360",
        "EN 361",
        "EN 362",
        "EN 397",
        "Le registre de sécurité (information à renseigner sur le registre)",
        "Création et utilisation d'un rapport de vérification",
        "Important : la formation est encore plus efficace si la partie pratique se fait à l'aide des EPI dont dispose le personnel de l'entreprise"
      ]
    }
  ],
  pedagogicalMethods: [
    "Exposés interactifs, démonstrations par le formateur, exercices sur site",
    "Support contextualisé, textes réglementaires et normatifs, EPI contre les chutes de hauteur"
  ],
  evaluationMethods: [
    "En 1er jour de la formation : Questionnaire des besoins et positionnement de l'apprenant",
    "Pendant la formation : Atelier pratique en situation réelle + exercices applicatifs",
    "Fin de formation : QCM pour évaluation des acquis + évaluation de satisfaction à chaud",
    "Après la formation : Évaluation à froid pour vérifier les compétences de l'apprenant"
  ],
  certification: "Cette action de formation sera validée par un certificat de réalisation nominative, après la réalisation du QCM final par évaluation des acquis.",
  registrationProcess: [
    "Inscription par téléphone, par mail ou par le site internet",
    "Délai d'accès selon un agenda interne de session de l'entreprise",
    "Inscription 15 jours avant le début de la formation"
  ],
  accessibilityCriteria: "Pour toute personne en situation d'handicap, Nous sommes susceptibles d'accueillir les personnes moins de nous contacter au préalable pour étudier toute situation.",
  formatterInfo: {
    name: "Sebastien Davrainville - SDPSI Formation",
    phone: "06.22.61.04.09",
    email: "sdpsiformation@orange.fr",
    website: "www.sdpsi-formations.fr"
  }
};
